import { z } from "zod";

export const TaxonomyStateItemSchema = z.object({
  State: z.string(),
  StateAbbreviation: z.string(),
});

export type TaxonomyStateItemType = z.infer<typeof TaxonomyStateItemSchema>;
